module.exports = __webpack_public_path__ + "static/img/bear3.93f887e5.png";